import { getQueryParameters, getUsageParameters, getIncludeNotHeldParameter, getSimulateActionsNode, getAttributionMethodParameter, getContributorDescriptors, getAnalyticsOutputParameter } from "./helpers"

export function riskFactorsQuery(options = {}) {
  const parameters = [getAnalyticsOutputParameter(options)]
  return `query (${getQueryParameters(parameters)}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode(parameters)} {
        ${riskFactorsQueryFragment(options)}
      }
    }
  }`
}

// QueryFragments are called by the rebalanceQuery so they need to include OpPro checks which are normally done before even calling the query
export function riskFactorsQueryFragment(options = {}) {
  const { isOpPro } = options
  if (isOpPro) { return "" }
  return `risk {
    attribution {
      factors {
        id
        category
        value
      }
    }
  }`
}

export function riskContributorsFactorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const attributionMethodParameter = getAttributionMethodParameter(options)
  const analyticsOuputParameter = getAnalyticsOutputParameter(options)

  return `query (${getQueryParameters([analyticsOuputParameter, includeNotHeldParameter, attributionMethodParameter])}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOuputParameter])} {
        ${riskContributorsFactorsQueryFragment([includeNotHeldParameter, attributionMethodParameter], options)}
      }
    }
  }`
}

// QueryFragments are called by the rebalanceQuery so they need to include OpPro checks which are normally done before even calling the query
export function riskContributorsFactorsQueryFragment(parameters = [], options = {}) {
  const { isOpPro } = options
  if (isOpPro) { return "" }
  return `riskContributors${getUsageParameters(parameters, true)} {
    ${getContributorDescriptors()}
    attribution {
      factors {
        id
        category
        value
      }
    }
  }`
}

export function groupedRiskContributorsFactorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const attributionMethodParameter = getAttributionMethodParameter(options)
  const analyticsOuputParameter = getAnalyticsOutputParameter(options)

  return `query (${getQueryParameters([analyticsOuputParameter, includeNotHeldParameter, attributionMethodParameter], true)}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOuputParameter])} {
        ${groupedRiskContributorsFactorsQueryFragment([includeNotHeldParameter, attributionMethodParameter], options)}
      }
    }
  }`
}

// QueryFragments are called by the rebalanceQuery so they need to include OpPro checks which are normally done before even calling the query
export function groupedRiskContributorsFactorsQueryFragment(parameters = [], options = {}) {
  const { isOpPro } = options
  if (isOpPro) { return "" }
  return `groupedRiskContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${getUsageParameters(parameters)}) {
    id
    name
    attribution {
      factors {
        id
        category
        value
      }
    }
    contributors{
      ${getContributorDescriptors()}
      attribution {
        factors {
          id
          category
          value
        }
      }
    }
  }`
}
